import { getApiData } from "./client";
export type { HomePublicConfig, HomeMaterialPreview } from "../../../shared/home-config";
import type { HomePublicConfig } from "../../../shared/home-config";
export const fetchHomeConfig = () => getApiData<HomePublicConfig>("/client/site/home");
